import React from 'react';
import * as VUCA from '../actions/viewUserCommonActions';

const init = {
  userId: "",
  emailAddress: "",
  status: "",
  lastLogin: "",
  passwordExpiration: "",
  firstName: "",
  middleName: "",
  lastName: "",
  phoneNumber: "",
  accountCreated: "",
  reasonDisabled: "",
  role: ""
}

export default function yourAccountReducers(state = init, action) {
    switch(action.type) {
          case VUCA.GET_VIEW_USER_COMMON_DATA:
            return {...state,
              userId: "1",
              emailAddress: "test@test.com",
              status: "Active",
              lastLogin: "6/6/2018",
              passwordExpiration: "6/28/2018",
              firstName: "Ryan",
              middleName: "Andrew",
              lastName: "Riggleman",
              phoneNumber: "1234567890",
              accountCreated: "6/1/2010",
              reasonDisabled: "N/A",
              role: "Admin"
            };
        default:
            return {
              ...state
        }
    }
  };
